import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import {Button, Table, Dropdown, Icon} from "semantic-ui-react"
import productStore from "stores/productStore"
import categoryStore from "stores/categoryStore"
import NavigationCategories from "components/Navigation/NavigationCategories"
import Sidebar from "components/Sidebar/Sidebar"
import CartMini from "components/Cart/CartMini"
import app from "app.controller"
import NavigationSidebar from "components/Navigation/NavigationSidebar"
import OrderlistSelection from "components/Orderlist/OrderlistSelection"
import Header from "components/Header/Header"
import Footer from "components/Footer/Footer"
import shop from "shop/shop"
import languageStore               from "stores/languageStore"
import "style/util.scss"
import "layout/PageLayout.scss"
import MediaQuery from "react-responsive"

class PageLayout extends Component {

  render() {
    const { currentLanguage } = languageStore
    return (
      <div className="PageLayout">
        <OrderlistSelection/>

        {/*SHOPPING CART*/}
        <Sidebar open={app.sidebar.open}
                 toggle={app.sidebar.toggle}
                 close={app.sidebar.close}>
          <CartMini/>
          {/* TO CART */}


        </Sidebar>

        <Sidebar
          left
          open={app.sidebarLeft.open}
          toggle={app.sidebarLeft.toggle}
          close={app.sidebarLeft.close}
        >
          <SidebarLeft currentLanguage={currentLanguage}/>

        </Sidebar>
        <Header/>
        <div className="page-content min-vh-100">
          {this.props.children}
        </div>
        <Footer/>
      </div>
    )
  }
}

const SidebarLeft = ({ currentLanguage }) => {
  let categoryData         = categoryStore.categories
  const {currentCategory}  = productStore
  const {categoryId}       = currentCategory
  const category           = categoryStore.categoriesById.get(categoryId)
  const {hash} = categoryStore
  return (
    <div className="SidebarLeft h-100 flex flex-column"  style={{backgroundColor: "#ffffff"}}>
      <div className="" style={{backgroundColor: "#ffffff"}}>
        <table style={{border: "none", boxShadow: "none"}} className="w-100 pa3">
          <colgroup>
            <col style={{width: "50px"}}/>
            <col style={{width: "50px"}}/>
            </colgroup>
          <tbody>
            <tr>
              <td className="pa3">
                        {<section className="pr2 pt2 pb1 f4 fw6 bb bw1 b--black-30 " >
                          <div className="flex flex-row justify-start">
              <p>{translate("Sprache ändern")}:</p>
              {languageStore.available.length > 1 && <Dropdown style={{color: "black"}} text={currentLanguage.toUpperCase()}
                          pointing
                          className="pl3 link item pt1">
              <Dropdown.Menu>
              {languageStore.available.map( locale => <Dropdown.Item className="tc"  style={{minWidth: "60px"}}
                key={locale}
                onClick={() => { languageStore.setLanguage(locale); this.props.history.push("/"); }}><p className="tc">{locale.toUpperCase()}</p></Dropdown.Item> )}
              </Dropdown.Menu>
              </Dropdown>}
              </div>
            </section> }
                
              </td>
              <td className="tr pa3" style={{verticalAlign: "top"}}>
                <Button floated="right" icon="close" style={{border: "none", backgroundColor: "#ffffff"}} onClick={app.sidebarLeft.toggle.dispatch}/>
              </td>
            </tr>
          </tbody>
        </table>
        {/* <div className="pa3 home-logo flex flex-row">
          <Link to="/" onClick={app.sidebarLeft.toggle.dispatch}>
            <img
              onLoad={(event) => {
                event.target.width /=2
              }}
              src={shop.config.logo ? shop.config.logo : undefined}
              alt="zur Startseite"/> 
          </Link>
          <div className="tr"></div>
        </div>*/}
        </div>
        <div className="overflow-y-auto overflow-x-auto pb6">
          <NavigationCategories key={hash} categories={categoryData} />
          <MediaQuery maxWidth={767}>
            <div className="flex flex-row justify-around pb3 pt5">
              <Fragment>
                {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && 
                  <Button
                    style={{
                      width: "150px",
                      height: "50px",
                      borderRadius: "25px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                    onClick={app.sidebarLeft.close.dispatch}
                    basic
                    inverted={false}
                    as={Link}
                    to={"/account"}
                  >
                    <Icon className="user circle" style={{margin: 0}} />
                  </Button>
                }
                {((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) &&
                  <Button
                    style={{
                      width: "150px",
                      height: "50px",
                      borderRadius: "25px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                    onClick={app.sidebarLeft.close.dispatch}
                    basic
                    inverted={false}
                    as={Link}
                    to={"/login"}
                  >
                    <Icon className="user circle" style={{margin: 0}} />
                  </Button>
                }
              </Fragment>
              <Fragment>
                <Button
                  style={{
                    width: "150px",
                    height: "50px",
                    borderRadius: "25px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  onClick={app.sidebarLeft.close.dispatch}
                  basic
                  inverted={false}
                  as={Link}
                  to={"/search/"}
                >
                  <Icon className="search" style={{margin: 0}} />
                </Button>
              </Fragment>
            </div>
            {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <div className="flex flex-row justify-around pb3 pt3">
                <Fragment>
                  <Fragment>
                    <Button
                      style={{
                        width: "150px",
                        height: "50px",
                        borderRadius: "25px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                      onClick={app.sidebarLeft.close.dispatch}
                      basic
                      inverted={false}
                      as={Link}
                      to={"/orderlist"}
                    >
                      <Icon className="heart" style={{margin: 0}} />
                    </Button>
                    <Button
                      style={{
                        width: "150px",
                        height: "50px",
                        borderRadius: "25px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                      onClick={app.sidebarLeft.close.dispatch}
                      basic
                      inverted={false}
                      as={Link}
                      to={"/quickorder"}
                    >
                      <Icon className="shopping basket" style={{margin: 0}} />
                    </Button>
                  </Fragment>
                </Fragment>
              </div>}
          </MediaQuery>
        </div>
              
        {/*<NavigationSidebar showTitle={false}/> */}
    </div>
  )
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/theme/demo2025/layout/PageLayout.js